module.exports = __webpack_public_path__ + "media/images/common/transfers/transfer-success-2x-444acfc431058f90f0d6292fc27d78e9.png";